import "../../../resources/less/Family/ThemePages/MonarchWoodland.less";
import BaseThematique from "./BaseThematique";

class MonarchWoodland extends BaseThematique {
  constructor() {
    super();
  }
}

$(window).on("load", () => {
  new MonarchWoodland();
});
